import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Global } from '@emotion/react';
import { Box } from '../../Box/index.js';
import { useTheme } from '../../hooks/useTheme.js';
import { useLayoutScreenContext } from '../LayoutScreen/LayoutScreenContext.js';

var LayoutHeader = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var handleStyleProps = useTheme().handleStyleProps;
    var header = useLayoutScreenContext().header;
    var forwardProps = handleStyleProps(props, {
        themeKey: "layoutHeader",
    });
    return (jsxs(Box, __assign({ "data-component": "LayoutHeader" }, forwardProps, { ref: header.ref }, { children: [jsx(Global, { styles: {
                    ":target": { scrollMarginTop: "var(--layout-header-height)" },
                } }), children] })));
};
LayoutHeader.displayName = "LayoutHeader";

export { LayoutHeader };
//# sourceMappingURL=LayoutHeader.js.map
